import Home from './Default/Home';
import Dashboard from './Default/Dashboard';
import CaseDetail from './Default/CaseDetail';
import DoseSpot from './Default/DoseSpot';
import Pharmacy from './Default/Pharmacy';
import BraintreeReports from './Default/Reports/BraintreeReports';
import MailOrder from './Default/MailOrder';
import MailOrderHoneybee from './Default/MailOrderHoneybee';


const AppRoutes = [
  {
    index: true,
        element: <Dashboard />
  },
  {
      path: '/Dashboard',
      element: <Dashboard />
    },
    {
        path: '/CaseDetail/:caseidParam',
        element: <CaseDetail />
    },
    {
        path: '/DoseSpot/:caseType/:token/:caseidParam/:refillidParam/:doseSpotidParam/:pharmacyidParam/:clinicianidParam',
        element: <DoseSpot />
    },
    {
        path: '/Pharmacy/:caseType/:token/:caseidParam/:refillidParam/:pharmacyidParam',
        element: <Pharmacy />
    },
    {
        path: '/BraintreeReports',
        element: <BraintreeReports />
    },
    {
        path: '/MailOrders',
        element: <MailOrder />
    },
    {
        path: '/MailOrdersHoneybee',
        element: <MailOrderHoneybee />
    },
    
];

export default AppRoutes;
